import React from 'react';
import { Card, Stack, Box, Avatar, Typography, Skeleton } from '@mui/material';
import OptionsMenu from './OptionsMenu'; // Import your custom OptionsMenu component
import { useContent } from '../../../../context/ContentContext';

// Function to generate Avatar from a string (e.g., initial letters)
function stringAvatar(name) {
    return {
        sx: {
            bgcolor: stringToColor(name), // Generates a random background color based on name
        },
        children: `${name.split(' ')[0][0]}${name.split(' ')[1] ? name.split(' ')[1][0] : ''}`, // Uses first letters of the name
    };
}

// Function to convert string to color for the Avatar background
function stringToColor(string) {
    let hash = 0;
    for (let i = 0; i < string.length; i++) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = '#';
    for (let i = 0; i < 3; i++) {
        color += ('00' + ((hash >> (i * 8)) & 0xff).toString(16)).slice(-2);
    }
    return color;
}

// Function to get a greeting based on the current time
function getGreeting(name) {
    const hour = new Date().getHours();
    const truncatedName = name.length > 10 ? `${name.slice(0, 10)}...` : name; // Truncate name if too long

    if (hour >= 6 && hour < 10) {
        return `Selamat Pagi, ${truncatedName}`;
    } else if (hour >= 10 && hour < 15) {
        return `Selamat Siang, ${truncatedName}`;
    } else if (hour >= 15 && hour < 18) {
        return `Selamat Sore, ${truncatedName}`;
    } else {
        return `Selamat Malam, ${truncatedName}`;
    }
}

const UserCard = ({ showGreeting = true }) => {
    const { userData } = useContent(); // Accessing user data from context

    if (!userData) {
        // Render skeletons while user data is loading
        return (
            <Card sx={{ width: '100%', padding: 2, boxShadow: 0, borderRadius: 2, backgroundColor: 'white' }}>
                <Stack direction="row" sx={{ gap: 1 }}>
                    <Skeleton variant="circular" width={45} height={45} />
                    <Box sx={{ flex: 1 }}>
                        <Skeleton variant="text" width="60%" height={20} />
                        <Skeleton variant="text" width="40%" height={15} />
                    </Box>
                </Stack>
            </Card>
        );
    }

    const { name, referral_id } = userData; // Destructure name and referral_id from user data

    return (
        <Card sx={{ width: '100%', padding: 2, boxShadow: 0, borderRadius: 2, backgroundColor: 'white' }}>
            <Stack
                direction="row"
                sx={{
                    gap: 1,
                    width: '100%', // Ensure the stack takes up 100% width of its parent
                }}
            >
                <Avatar {...stringAvatar(name)} sx={{ width: 45, height: 45 }} />
                <Box sx={{ mr: 'auto' }}>
                    {/* Conditionally render greeting message based on showGreeting prop */}
                    {showGreeting && (
                        <Typography
                            variant="body2"
                            sx={{
                                fontWeight: 500,
                                lineHeight: '16px',
                                marginTop: '5px',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                maxWidth: 250, // Set maximum width for truncation
                            }}
                        >
                            {getGreeting(name)}
                        </Typography>
                    )}
                    {/* Referral code with TextField */}
                    <Typography
                        variant="caption"
                        sx={{
                            color: 'text.secondary',
                            fontSize: '0.75rem', // Smaller font size
                            marginTop: 0,       // Adjust spacing
                            display: 'block',   // Ensures proper layout as a separate line
                        }}
                    >
                        {referral_id} {/* Display the referral ID */}
                    </Typography>
                </Box>
            </Stack>
        </Card>
    );
};

export default UserCard;
